// extracted by mini-css-extract-plugin
module.exports = {"w11gfz5q":"w11gfz5q"};